import React from "react";

import { installGoogleAds } from "../../helpers";

export default class GooglePanelsAd extends React.Component {
  componentDidMount() {
    installGoogleAds();
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  // <!-- Dashboard Panels Ad -->
  render() {
    return (
      <ins className="adsbygoogle google-panels-ad"
        style={{ display: "block" }}
        data-ad-client="ca-pub-7228983401564876"
        data-ad-slot="9034763599"
        // data-ad-format="auto"
        data-full-width-responsive="false"></ins>
    );
  }
}
